import Phaser from 'phaser';
import gameState from 'tower/state/game-state';
import { RoomConfig } from 'tower/types';
import Enemy from 'tower/scenes/battle/enemy';
import Gel from './enemy/gel';
import { asyncAnimation, asyncTween, Direction, onPointer } from 'tower/util';
import MrWall from './enemy/mrwall';
import * as C from 'tower/constants';
import Statue from './enemy/statue';
import OldMan from './enemy/oldman';
import RoomText from './roomtext';
import Item from './item';
import OtherManager, { Other } from './other';
import sharedWorker from 'tower/state/worker';
import Boss from './boss';
import Interactable from './interactable';
import Mummy from './enemy/mummy';

const FLOOR1: RoomConfig[] = [
  {
    key: 'start',
    checkpoint: true,
    floorX: 3,
    floorY: 8,
    doorsConfig: { up: 'locked', down: 'closed', left: null, right: null },
    entityConfigs: [
      { type: 'key', spaceX: 7, spaceY: 3 },
      { type: 'statue', spaceX: 3, spaceY: 1, options: { facing: 'right', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 5, spaceY: 1, options: { facing: 'right', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 3, spaceY: 3, options: { facing: 'right', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 5, spaceY: 3, options: { facing: 'right', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 3, spaceY: 5, options: { facing: 'right', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 5, spaceY: 5, options: { facing: 'right', color: 'grey', disabled: true } },

      { type: 'statue', spaceX: 9, spaceY: 1, options: { facing: 'left', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 11, spaceY: 1, options: { facing: 'left', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 9, spaceY: 3, options: { facing: 'left', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 9, spaceY: 5, options: { facing: 'left', color: 'grey', disabled: true } },
      { type: 'statue', spaceX: 11, spaceY: 5, options: { facing: 'left', color: 'grey', disabled: true } },
    ],
    playerSpawn: { spaceX: 1, spaceY: 3 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        return () => null;
      }

      room.spawnEntity({
        type: 'statue',
        spaceX: 11,
        spaceY: 3,
        options: { facing: 'left', color: 'grey', disabled: true, hp: 3 },
      });

      let killCount = 0;
      const handleEnemyDeath = (enemy: Enemy) => {
        killCount++;
        if (killCount === 1) {
          scene.sound.play('secret');
          gameState.solveRoom(this.key);
          gameState.addRoomItem(this.key, { id: `heart[${this.key}]`, type: 'heart3', x: enemy.x, y: enemy.y });
        }
      };

      scene.events.on('enemydeath', handleEnemyDeath);

      return () => {
        scene.events.off('enemydeath', handleEnemyDeath);
      };
    },
    serializedLinks:
      'AAICAAACAgIAAgICAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAgIAAgICAAACAgIBAgACAQEBAgECAQECAgEBAQECAQICAQEBAQIBAQEBAQEBAQECAQEBAQICAQIBAQEBAgICAQIBAgEBAQIAAgECAQIAAQIBAQIBAgICAgEBAQEBAgICAQEBAQECAQEBAQEBAQEBAgEBAgEBAgECAQECAQECAgICAQEBAQICAAIBAgICAAEBAQICAQIBAQICAQEBAQIBAgIBAQEBAgEBAQEBAQEBAQIBAQEBAgIBAgEBAQECAgIBAgEBAgEBAgACAgICAgABAQECAgECAQICAQEBAQECAgIBAQEBAQIBAQEBAQEBAQECAQECAQECAQIBAQIBAQICAQIBAQIBAQIAAgICAQIAAQIBAQIBAgIBAgIBAQEBAgECAgEBAQECAQEBAQEBAQEBAgEBAQECAgECAQEBAQICAgICAQEBAQICAAIBAgECAAEBAgECAQIBAgIBAQEBAQICAgEBAQEBAgEBAQEBAQEBAQIBAQIBAQIBAgEBAgEBAgIBAgEBAQIBAgACAQICAAACAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAICAgACAgIAAgIAAAI=',
  },
  {
    key: 'oldstart',
    floorX: 3,
    floorY: 7,
    doorsConfig: { up: 'locked', down: 'locked', left: null, right: null },
    entityConfigs: [
      { type: 'key', spaceX: 12, spaceY: 4 },
      { type: 'gel', spaceX: 10, spaceY: 4 },
      { type: 'gel', spaceX: 2, spaceY: 3 },
      { type: 'gel', spaceX: 6, spaceY: 5 },
      { type: 'gel', spaceX: 6, spaceY: 1 },
      { type: 'gel', spaceX: 13, spaceY: 2 },
    ],
    playerSpawn: { spaceX: 7, spaceY: 3 },
    onCreate(scene) {
      if (gameState.isRoomSolved(this.key)) {
        return () => null;
      }

      let killCount = 0;
      const handleEnemyDeath = (enemy: Enemy) => {
        if (enemy.enemyType === 'gel') {
          killCount++;
          if (killCount === 3) {
            scene.sound.play('secret');
            gameState.solveRoom(this.key);
            gameState.addRoomItem(this.key, { id: 'boomerang', type: 'boomerang', x: enemy.x, y: enemy.y });
          }
        }
      };

      scene.events.on('enemydeath', handleEnemyDeath);

      return () => {
        scene.events.off('enemydeath', handleEnemyDeath);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgICAAICAgACAQIAAgECAAICAgACAQIAAgECAAICAgACAQIAAgICAAIBAgACAQIAAgICAAACAgIBAgABAgEBAgECAgICAgEBAQICAQICAQICAQIBAQICAQICAQICAQIBAQECAgECAQECAgEBAQICAgECAQIAAgECAQIAAQICAQIBAgICAQEBAgEBAQIBAQEBAgIBAgEBAgICAgEBAQECAQIBAQIBAQICAQEBAgECAQIBAQECAAIBAgECAAIBAQECAQEBAQIBAQECAQIBAgECAgEBAgEBAgECAQEBAQECAQECAQEBAgICAQEBAgICAgEBAgICAgACAgIBAgABAgEBAQECAgEBAgEBAQIBAQECAQECAQECAQICAQIBAQICAQIBAgECAgICAgECAgICAQICAgEBAQIAAgECAQIAAQICAQIBAgICAQIBAgICAQIBAQIBAQIBAgIBAQEBAgIBAQIBAQECAQIBAQECAQIBAgEBAQEBAgECAAIBAgECAAIBAQECAQIBAgIBAQICAgIBAgECAgIBAgEBAQICAgEBAgICAgIBAQIBAgEBAgEBAgECAQECAQICAgACAQICAAABAgACAgIAAgECAAICAgACAQIAAgECAAIBAgACAQIAAgICAAIBAgACAQIAAgECAAIBAgACAgIAAgIAAAI=',
  },
  {
    key: 'second',
    floorX: 3,
    floorY: 6,
    doorsConfig: { up: null, down: 'locked', left: 'locked', right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 4, spaceY: 1 },
      { type: 'gel', spaceX: 7, spaceY: 0, variant: 'black' },
      { type: 'gel', spaceX: 2, spaceY: 3, variant: 'black' },
      { type: 'gel', spaceX: 2, spaceY: 1 },
      { type: 'gel', spaceX: 10, spaceY: 3 },
      { type: 'gel', spaceX: 13, spaceY: 0 },
    ],
    playerSpawn: { spaceX: 7, spaceY: 3 },
    onCreate(scene) {
      if (gameState.isRoomSolved(this.key)) {
        return () => null;
      }

      let killCount = 0;
      const handleEnemyDeath = (enemy: Gel) => {
        if (enemy.enemyType === 'gel' && enemy.variantType === 'black') {
          killCount++;
          if (killCount === 2) {
            scene.sound.play('secret');
            gameState.solveRoom(this.key);
            gameState.addRoomItem(this.key, { id: `heart[${this.key}]`, type: 'heart1', x: enemy.x, y: enemy.y });
          }
        }
      };

      scene.events.on('enemydeath', handleEnemyDeath);

      return () => {
        scene.events.off('enemydeath', handleEnemyDeath);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAICAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAgIAAgECAAACAgICAgABAgECAQEBAgECAQEBAQICAQECAQIBAgEBAgEBAQICAgECAgIBAgECAQECAgECAQECAgECAQEBAgIAAgECAgIAAQICAgEBAQIBAgEBAgIBAgICAgICAgECAQIBAgIBAgICAQEBAQIBAQIBAgIBAgIBAQICAgECAgICAAICAgECAAICAQEBAQECAQIBAQEBAgICAQIBAQECAQEBAgECAQEBAQIBAQECAQICAQICAgECAQIBAQECAQEBAgACAQIBAgABAgIBAQEBAgEBAgECAQIBAgIBAQICAgICAQECAQIBAQECAQIBAQICAgECAQIBAQEBAQIBAQIBAQIAAgICAQIAAgECAQEBAgECAQIBAgICAQEBAgICAgEBAQICAgEBAQIBAQIBAgECAQICAgEBAQECAgIBAQEBAgICAAIBAgECAAICAgECAQECAgIBAQIBAQICAgIBAQEBAgIBAQEBAgEBAgIBAgIBAgICAQEBAQECAQECAQECAgECAgACAgICAAACAgACAQIAAgECAAIBAgACAgIAAgECAAIBAgACAQIAAgECAAICAgACAQIAAgICAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'diamondsecret',
    floorX: 2,
    floorY: 6,
    doorsConfig: { up: null, down: null, left: null, right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 3, spaceY: 3 },
      { type: 'bladeTrap', spaceX: 12, spaceY: 0 },
      { type: 'bladeTrap', spaceX: 12, spaceY: 6 },
      { type: 'bladeTrap', spaceX: 2, spaceY: 0 },
      { type: 'bladeTrap', spaceX: 2, spaceY: 6 },
    ],
    playerSpawn: { spaceX: 3, spaceY: 4 },
    onCreate(scene, room) {
      let mattock: Item | null = null;

      // Spawn mattock if you don't have one
      if (!gameState.hasItem('mattock') && !gameState.hasItem('betterMattock')) {
        mattock = room.spawnEntity({ id: 'mattock', type: 'mattock', spaceX: 7, spaceY: 3 }) as Item;
      }

      // Mr. Wall is not around if the room has been solved
      if (gameState.isRoomSolved(this.key)) {
        room.maze.removeWall(room.maze.getNode(10, 3), Direction.Down);
        return () => null;
      }

      // Fallback that probably isn't used to ensure mattock isn't null
      if (mattock === null) {
        mattock = room.spawnEntity({ id: 'mattock', type: 'mattock', spaceX: 7, spaceY: 3 }) as Item;
      }

      // The wonderful Mr.Wall
      const mrWall = room.spawnEntity({ type: 'mrWall', spaceX: 5, spaceY: 3 }) as MrWall;

      // Mr. Wall replaces himself once you get the mattock
      mattock.on('collect', async () => {
        const [wx, wy] = room.maze.spaceXYToWorldXY(5, 3);
        const image = scene.add.image(wx, wy - 12, 'enemies', 7);
        await asyncTween(scene, {
          y: wy + 12,
          targets: [image],
          duration: 500,
        });
        room.maze.toggleWall(mrWall.mazeNode, Direction.Right);
        gameState.solveRoom(this.key);
        image.destroy();
      });

      return () => {};
    },
    serializedLinks:
      'AAICAAACAgIAAgICAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAgIAAgICAAACAgICAgACAgICAgECAgEBAQEBAQEBAQEBAQEBAQEBAgIBAQECAgEBAQEBAQEBAQEBAQEBAQECAgIBAgICAgIAAgICAgIAAgICAgIBAgIBAQEBAQEBAQEBAQEBAgIBAgEBAgICAQEBAQICAQEBAQEBAQEBAQEBAgICAQICAgICAAICAgICAAICAgICAQICAQEBAQEBAQEBAgIBAgEBAgEBAQEBAQEBAgIBAQEBAgIBAQEBAQEBAQICAQECAgECAgACAgICAgACAgICAgECAgEBAQEBAQEBAgIBAQEBAgIBAQEBAQEBAQECAgECAQECAQEBAQEBAQEBAgIBAQICAgIAAgICAgIAAgICAgIBAgIBAQEBAQEBAQEBAQECAgEBAQECAgECAgECAQECAQEBAQEBAQEBAQEBAgICAQICAgICAAICAgICAAICAgICAQICAQEBAQEBAQEBAQEBAQEBAQICAQECAQECAQEBAQEBAQEBAQEBAQEBAQICAgECAgICAgACAgICAAACAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAICAgACAgIAAgIAAAI=',
  },
  {
    key: 'knightsintodreams',
    floorX: 4,
    floorY: 6,
    doorsConfig: { up: 'locked', down: null, left: 'locked', right: null },
    entityConfigs: [
      { type: 'key', spaceX: 7, spaceY: 1 },
      { type: 'knight', spaceX: 3, spaceY: 3, variant: 'green', options: { blockedSpaces: [{ x: 4, y: 5 }] } },
      {
        type: 'knight',
        spaceX: 8,
        spaceY: 5,
        variant: 'red',
        options: {
          blockedSpaces: [
            { x: 4, y: 5 },
            { x: 12, y: 5 },
          ],
        },
      },
      {
        type: 'knight',
        spaceX: 12,
        spaceY: 1,
        variant: 'blue',
        options: {
          blockedSpaces: [
            { x: 8, y: 2 },
            { x: 12, y: 4 },
          ],
        },
      },
    ],
    playerSpawn: { spaceX: 7, spaceY: 2 },
    onCreate(scene) {
      if (gameState.isRoomSolved(this.key)) {
        return () => null;
      }

      const killOrder = ['red', 'green', 'blue'];
      let killIndex = 0;
      const handleEnemyDeath = (enemy: Gel) => {
        if (killIndex < 3 && enemy.enemyType === 'knight' && killOrder[killIndex] === enemy.variantType) {
          killIndex++;
          if (killIndex === 3) {
            scene.sound.play('secret');
            gameState.solveRoom(this.key);
            gameState.addRoomItem(this.key, { id: `candle`, type: 'candle', x: enemy.x, y: enemy.y });
          }
        }
      };

      scene.events.on('enemydeath', handleEnemyDeath);

      return () => {
        scene.events.off('enemydeath', handleEnemyDeath);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgICAAICAgACAQIAAgECAAICAgACAQIAAgECAAICAgACAQIAAgECAAIBAgACAQIAAgECAAACAgIBAgABAQIBAgEBAQIBAgEBAQIBAQICAQIBAgIBAQEBAQEBAQIBAgEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAgICAQEBAQICAQEBAgEBAQIBAQECAQIBAQEBAQEBAQECAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAICAgEBAgECAQEBAgECAQEBAgICAgIBAgECAQIBAgECAQIBAgECAQIBAgECAQECAgEBAQEBAQEBAgACAQICAgACAQECAQICAQECAQIBAQICAgICAQEBAQIBAgEBAQEBAgECAQEBAQECAQIBAQIBAgIBAgEBAQIBAgIAAgICAQIAAQECAQIBAQEBAgEBAgIBAgIBAQIBAgEBAQEBAgECAQEBAQECAQIBAQEBAQICAgEBAQIBAgEBAgICAAIBAgECAAICAQEBAQICAQECAQECAQEBAgICAQEBAgECAQEBAQECAQIBAQEBAQIBAgEBAQECAgEBAgECAQEBAgACAQICAAABAgACAgIAAgICAAIBAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgICAAICAgACAQIAAgIAAAI=',
  },
  {
    key: 'afranklyabsurdamountofwalls',
    floorX: 4,
    floorY: 5,
    dark: true,
    doorsConfig: { up: 'locked', down: 'locked', left: 'locked', right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 7, spaceY: 4 },
      { type: 'knight', spaceX: 2, spaceY: 5, variant: 'green' },
      {
        type: 'knight',
        spaceX: 7,
        spaceY: 2,
        variant: 'red',
        options: {
          blockedSpaces: [
            { x: 7, y: 3 },
            { x: 3, y: 3 },
          ],
        },
      },
      { type: 'gel', spaceX: 11, spaceY: 1, variant: 'black' },
      { type: 'gel', spaceX: 11, spaceY: 5, variant: 'black' },

      { type: 'ghost', spaceX: 3, spaceY: 5, variant: 'blue', options: { orientation: 'horizontal' } },
      { type: 'ghost', spaceX: 9, spaceY: 2, variant: 'blue', options: { orientation: 'horizontal' } },
    ],
    playerSpawn: { spaceX: 7, spaceY: 6 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        // Spawn mattock if you don't have one and have previously solved the room
        if (!gameState.hasItem('betterMattock')) {
          room.spawnEntity({ id: 'betterMattock', type: 'betterMattock', spaceX: 9, spaceY: 3 });
        }
        return () => {};
      }

      const handleMattockDurabilityChange = (value: number, previous: number) => {
        if (value === 0 && previous === 1) {
          scene.sound.play('secret');
          room.spawnEntity({ id: 'betterMattock', type: 'betterMattock', spaceX: 9, spaceY: 3 });
          gameState.solveRoom(this.key);
          gameState.off('mattockdurabilitychange', handleMattockDurabilityChange);
        }
      };
      gameState.on('mattockdurabilitychange', handleMattockDurabilityChange);

      return () => {
        gameState.off('mattockdurabilitychange', handleMattockDurabilityChange);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgICAAIBAgACAgIAAgICAAIBAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAgIAAgECAAACAgIBAgABAgIBAgIBAgECAgICAgECAgICAgECAQICAgECAQICAgECAQIBAQECAQECAQECAQECAgICAQECAgIAAgECAgIAAgECAgEBAgECAQEBAQECAQICAQEBAgICAQEBAgICAgEBAQECAQICAQIBAQIBAQIBAgECAQIBAgECAAIBAgECAAICAQECAgECAQEBAgICAgEBAQECAgICAQEBAQICAQEBAQIBAQIBAgIBAgEBAgECAgIBAQECAQIBAgACAQICAgABAgECAQICAgECAQICAgICAQECAgIBAQEBAgIBAQIBAgECAQICAgECAQEBAgIBAgEBAgEBAgEBAgIAAgECAgIAAQEBAgIBAQEBAgEBAgEBAgICAQEBAgECAgICAgECAgIBAgECAQICAgECAQICAQECAQICAQECAQICAAICAgICAAECAQIBAgECAQIBAgECAQIBAgECAQIBAgIBAQICAQEBAQECAQIBAQEBAQIBAQIBAQICAQIBAQECAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgICAAIBAgACAgIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'therearemanydoors',
    floorX: 5,
    floorY: 5,
    dark: true,
    doorsConfig: { up: null, down: null, left: 'locked', right: null },
    entityConfigs: [
      { type: 'key', spaceX: 14, spaceY: 0 },
      { type: 'ghost', spaceX: 2, spaceY: 6, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 11, spaceY: 2, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 8, spaceY: 6, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 7, spaceY: 1, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 13, spaceY: 5, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 10, spaceY: 1, variant: 'blue', options: { orientation: 'horizontal' } },
      { type: 'ghost', spaceX: 3, spaceY: 2, variant: 'blue', options: { orientation: 'horizontal' } },
      { type: 'ghost', spaceX: 8, spaceY: 4, variant: 'blue', options: { orientation: 'horizontal' } },
      { type: 'ghost', spaceX: 5, spaceY: 5, variant: 'blue', options: { orientation: 'horizontal' } },
    ],
    playerSpawn: { spaceX: 0, spaceY: 3 },
    onCreate(scene) {
      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      scene.deathState = 'ghostDeath';
      return () => {
        scene.deathState = 'death';
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgICAAICAgACAQIAAgECAAIBAgACAgIAAgICAAIBAgACAQIAAgECAAACAgIBAgABAgEBAQIBAgECAQIBAQICAgEBAQICAQEBAQICAQIBAQEBAgICAQEBAgICAQEBAQIBAgEBAQIBAgIAAgICAQIAAQECAQEBAgEBAgEBAgECAgECAQEBAQICAgECAQEBAgECAgIBAQEBAgICAgEBAQECAQIBAQECAQICAAICAgICAAICAQICAQICAQIBAQICAgIBAgICAgEBAgICAgECAQECAgECAQECAgECAgICAQIBAgECAQIBAQICAgACAQICAgABAQECAgECAQECAgECAgICAgEBAgECAQECAQICAQICAQIBAQICAQEBAgECAQECAQEBAQICAgEBAQIAAgECAQIAAQECAQIBAgECAQIBAgECAQECAQEBAgECAgECAgIBAgEBAgEBAQIBAgICAgIBAQECAgIBAQECAQICAAICAgECAAICAQECAQECAgEBAQIBAgEBAQIBAQIBAQIBAQICAgEBAQECAgECAQECAgECAQIBAgECAQIBAQECAgACAQICAAABAgACAQIAAgECAAICAgACAgIAAgECAAIBAgACAQIAAgICAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'pressthebuttondawg',
    floorX: 3,
    floorY: 5,
    doorsConfig: { up: 'open', down: null, left: 'locked', right: 'locked' },
    dark: true,
    entityConfigs: [
      { type: 'key', spaceX: 2, spaceY: 2 },
      { type: 'wizard', spaceX: 2, spaceY: 6, variant: 'red' },
      { type: 'wizard', spaceX: 2, spaceY: 6, variant: 'red' },
      { type: 'gel', spaceX: 11, spaceY: 3, variant: 'black' },
      { type: 'gel', spaceX: 8, spaceY: 2, variant: 'black' },
      { type: 'gel', spaceX: 3, spaceY: 3, variant: 'black' },
    ],
    playerSpawn: { spaceX: 0, spaceY: 3 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      const button = scene.physics.add.sprite(...room.maze.spaceXYToWorldXY(7, 3), 'enemies', 15);
      room.misc.add(button);
      button.setImmovable(true).setDepth(C.DEPTHS.Enemies);
      scene.input.enable(button, {
        hitArea: new Phaser.Geom.Rectangle(button.x - 7, button.y - 6, 14, 12),
        useHandCursor: true,
      });
      onPointer(button, {
        click: async () => {
          // No button when dying
          if (!scene.isPlaying) {
            return;
          }

          gameState.addRoomItem(this.key, { id: 'whiteSword', type: 'whiteSword', x: button.x, y: button.y });
          gameState.solveRoom(this.key);
          scene.sound.play('secret');
          await asyncAnimation(button, 'enemySpawn');
          button.destroy(true);
        },
      });
      const collider = scene.physics.add.collider(scene.player, button);
      return () => {
        button.destroy(true);
        collider.destroy();
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgICAAIBAgACAQIAAgECAAIBAgACAgIAAgICAAICAgACAQIAAgICAAIBAgACAQIAAgECAAACAgIBAgABAgIBAgEBAgECAQEBAgECAQECAgECAgECAQICAgEBAQIBAQEBAgIBAgIBAgEBAQIBAgIBAQEBAgIAAgECAQIAAgECAQEBAgEBAQIBAQECAQICAQECAQICAgIBAQEBAQIBAQIBAgEBAQECAgEBAgECAgEBAgEBAgECAAIBAgECAAIBAQECAgEBAgEBAgICAgEBAQICAgEBAQECAgEBAgICAgIBAgEBAQICAgIBAQIBAgECAQICAQICAgACAQIBAgABAgEBAQICAgECAQICAQICAgECAQECAQECAQECAgIBAQEBAQIBAgEBAgEBAgEBAgEBAQIBAgEBAQIAAgECAQIAAQECAQIBAQEBAgIBAgEBAgIBAQEBAgIBAQIBAgEBAQIBAgEBAQECAgECAQECAgECAgIBAgEBAQICAAIBAgICAAICAQIBAQECAgEBAQECAgEBAQECAgECAQECAgEBAQECAQIBAQICAQIBAgECAQECAgECAgEBAQECAgACAQICAAABAgACAQIAAgECAAICAgACAQIAAgICAAICAgACAQIAAgECAAIBAgACAQIAAgICAAICAgACAQIAAgIAAAI=',
  },
  {
    key: 'throwinroom',
    floorX: 4,
    floorY: 4,
    doorsConfig: { up: 'locked', down: 'locked', left: 'locked', right: null },
    entityConfigs: [
      { type: 'key', spaceX: 11, spaceY: 4 },
      { type: 'mummy', spaceX: 2, spaceY: 6, variant: 'blue' },
      { type: 'mummy', spaceX: 9, spaceY: 3, variant: 'blue' },
      { type: 'mummy', spaceX: 6, spaceY: 2, variant: 'blue' },

      { type: 'ghost', spaceX: 5, spaceY: 3, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 13, spaceY: 3, variant: 'blue', options: { orientation: 'horizontal' } },
    ],
    playerSpawn: { spaceX: 7, spaceY: 0 },
    onCreate(scene) {
      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      const handleMummyBurned = (mummy: Mummy) => {
        mummy.heldItem = 'heart2';
        mummy.once('destroy', () => {
          gameState.solveRoom(this.key);
        });
        scene.sound.play('secret');
        scene.events.removeListener('mummyburned', handleMummyBurned);
      };
      scene.events.addListener('mummyburned', handleMummyBurned);

      return () => {
        scene.events.removeListener('mummyburned', handleMummyBurned);
      };
    },
    serializedLinks:
      'AAICAAACAgIAAgECAAICAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAICAgACAQIAAgICAAACAgIBAgACAgIBAQECAgIBAQECAQEBAQECAQECAQEBAgECAQICAgECAQIBAgECAQECAgICAQEBAQECAgEBAQIAAgECAQIAAgECAQIBAQEBAQIBAQIBAQICAQIBAgECAQECAgIBAQEBAgEBAQICAgICAQIBAQICAQIBAQECAgICAAICAgECAAIBAQEBAgEBAgICAgEBAQIBAgEBAQIBAgICAQIBAQICAQICAQIBAQIBAgEBAgICAgEBAQICAQEBAgACAQIBAgABAgEBAQIBAgIBAgIBAQIBAQECAQECAQEBAgECAgECAgIBAgEBAQIBAQIBAQIBAgIBAQIBAQIBAQIAAgICAgIAAQEBAgEBAgECAgEBAgECAgICAgEBAQECAQICAQIBAQICAQEBAgIBAQECAgICAgECAgEBAgEBAgECAAIBAgECAAECAgECAQECAQIBAQICAQICAgICAQEBAgIBAQEBAgEBAQIBAgECAQICAQECAQECAQECAQECAgECAgACAgICAAACAgACAQIAAgECAAIBAgACAgIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgICAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'unrealeyes',
    floorX: 3,
    floorY: 4,
    doorsConfig: { up: 'locked', down: 'open', left: null, right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 6, spaceY: 3 },
      { type: 'wisp', spaceX: 6, spaceY: 3, options: { pattern: 'urduuurrddludddldllurlluurdullurrrrdld' } },
      { type: 'wisp', spaceX: 4, spaceY: 4, options: { pattern: 'rddluluulluurrdlrrdd' } },
      { type: 'wisp', spaceX: 11, spaceY: 4, options: { pattern: 'uruulrullldrlddrurlddr' } },
      { type: 'ghost', spaceX: 2, spaceY: 3, variant: 'blue', options: { orientation: 'vertical' } },
      { type: 'ghost', spaceX: 10, spaceY: 1, variant: 'blue', options: { orientation: 'vertical' } },
    ],
    playerSpawn: { spaceX: 7, spaceY: 4 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      const fakeWalls = [
        { node: room.maze.getNode(2, 3), direction: Direction.Down },
        { node: room.maze.getNode(11, 4), direction: Direction.Down },
        { node: room.maze.getNode(6, 1), direction: Direction.Down },
      ];
      const handleWallRemoved = () => {
        const solved = fakeWalls.every(({ node, direction }) => !node.links[direction]);
        if (solved) {
          const [x, y] = room.maze.spaceXYToWorldXY(7, 3);
          gameState.addRoomItem(this.key, { id: `wispRing`, type: 'wispRing', x, y });
          gameState.solveRoom(this.key);
          scene.sound.play('secret');
          scene.events.removeListener('removewall', handleWallRemoved);
        }
      };
      scene.events.addListener('removewall', handleWallRemoved);

      return () => {
        scene.events.removeListener('removewall', handleWallRemoved);
      };
    },
    serializedLinks:
      'AAICAAACAgIAAgECAAICAgACAQIAAgECAAICAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgICAAACAgIBAgACAQIBAQIBAQICAQIBAgECAQEBAgICAgEBAQECAQICAQEBAgIBAgEBAQICAgEBAQIBAgIBAgECAgIAAgECAQIAAgEBAQECAgEBAQECAQIBAQECAQICAgICAQEBAgIBAgECAQEBAQICAQICAQIBAQICAgECAQIBAQECAAIBAgICAAEBAQICAgIBAQIBAgEBAgIBAQIBAgECAQEBAgECAQIBAQECAQIBAQEBAgIBAgEBAgIBAQEBAQEBAgACAQIBAgABAgIBAgIBAgEBAQICAQIBAgIBAQICAQICAgICAgEBAgICAgEBAQECAgECAQEBAgEBAgIBAQEBAgIAAgECAgIAAgICAgEBAQIBAQIBAgIBAQEBAgIBAgEBAgEBAgECAgECAgECAQEBAgIBAgECAgIBAgIBAgECAQICAAICAgECAAIBAQEBAQIBAgIBAQEBAgICAQEBAQECAQECAQECAQICAQECAQECAQECAQICAgIBAQECAQIBAQECAgACAQICAAABAgACAgIAAgECAAICAgACAQIAAgICAAIBAgACAgIAAgICAAIBAgACAgIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'statueroom',
    floorX: 2,
    floorY: 3,
    doorsConfig: { up: null, down: 'locked', left: null, right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 10, spaceY: 3 },
      { type: 'wisp', spaceX: 7, spaceY: 1, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 8, spaceY: 5, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 9, spaceY: 2, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 10, spaceY: 6, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 11, spaceY: 0, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 12, spaceY: 4, offsetX: -12, options: { still: true } },
      { type: 'wisp', spaceX: 13, spaceY: 1, offsetX: -12, options: { still: true } },
    ],
    playerSpawn: { spaceX: 7, spaceY: 4 },
    onCreate(scene, room) {
      const statueConfigs = [
        { type: 'statue', spaceX: 3, spaceY: 1, options: { facing: 'right', color: 'grey', disabled: false } },
        {
          type: 'statue',
          spaceX: 3,
          spaceY: 3,
          options: { facing: 'right', color: 'red', pushable: true, disabled: false },
        },
        { type: 'statue', spaceX: 3, spaceY: 5, options: { facing: 'right', color: 'grey', disabled: false } },
      ];

      if (gameState.isRoomSolved(this.key)) {
        for (const statueConfig of statueConfigs) {
          statueConfig.options.disabled = true;
          room.spawnEntity(statueConfig);
        }
        return () => {};
      }

      for (const statueConfig of statueConfigs) {
        room.spawnEntity(statueConfig);
      }

      const handleStatuePushed = () => {
        for (const enemyObject of room.enemies.children) {
          const enemy = enemyObject as Enemy;
          if (enemy.enemyType === 'statue') {
            (enemy as Statue).disable();
          }
        }

        const [x, y] = room.maze.spaceXYToWorldXY(1, 3);
        gameState.addRoomItem(this.key, { id: `bow`, type: 'bow', x, y });
        gameState.solveRoom(this.key);
        scene.sound.play('secret');

        scene.events.removeListener('statuepushed', handleStatuePushed);
      };
      scene.events.addListener('statuepushed', handleStatuePushed);

      return () => {
        scene.events.removeListener('statuepushed', handleStatuePushed);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAgIAAgICAAICAgACAgIAAgECAAICAgACAgIAAgECAAACAgIBAgABAQEBAQEBAQECAgEBAQECAQEBAQEBAQECAQEBAgECAQIBAgECAQIBAQECAQIBAgECAQEBAQEBAQIAAgECAQIAAQEBAQEBAQECAgEBAQEBAgEBAQEBAQEBAQECAQIBAgECAQEBAgECAQIBAgECAQIBAQECAQEBAQECAAIBAgECAAEBAQEBAQEBAQICAQEBAQIBAQEBAQEBAQIBAgECAQIBAQECAQIBAgECAQIBAgECAQIBAgEBAQEBAgACAQIBAgABAQEBAQEBAQICAQEBAQECAQEBAQEBAQECAQIBAgECAQIBAgECAQIBAgECAQIBAQECAQIBAQEBAQIAAgECAQIAAQEBAQEBAQEBAgIBAQEBAgEBAQEBAQEBAgECAQIBAQECAQIBAgECAQIBAgEBAQIBAgECAQEBAQECAAIBAgECAAEBAQEBAQEBAgIBAQEBAQIBAQEBAQEBAQIBAgEBAQIBAgECAQIBAQECAQIBAgECAQIBAgEBAQEBAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAICAgACAgIAAgICAAIBAgACAgIAAgICAAICAgACAQIAAgIAAAI=',
  },
  {
    key: 'foundforest',
    floorX: 2,
    floorY: 5,
    doorsConfig: { up: null, down: null, left: null, right: 'locked' },
    entityConfigs: [
      { type: 'key', spaceX: 7, spaceY: 4 },
      { type: 'flame', spaceX: 9, spaceY: 3, options: { persist: true } },
      { type: 'flame', spaceX: 5, spaceY: 3, options: { persist: true } },
    ],
    playerSpawn: { spaceX: 7, spaceY: 4 },
    onCreate(scene, room) {
      room.floorSprite.setFrame(2);

      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      let solutionMatch = true;
      const solution = [
        'pressthebuttondawg',
        'unrealeyes',
        'throwinroom',
        'afranklyabsurdamountofwalls',
        'therearemanydoors',
      ];
      for (let k = 0; k < solution.length; k++) {
        if (solution[k] !== gameState.roomHistory[k]) {
          solutionMatch = false;
          break;
        }
      }

      if (solutionMatch) {
        const [x, y] = room.maze.spaceXYToWorldXY(7, 3);
        gameState.addRoomItem(this.key, { id: `blueTunic`, type: 'blueTunic', x, y });
        gameState.solveRoom(this.key);
        scene.sound.play('secret');

        return () => {};
      }

      const text = new RoomText(
        scene,
        room,
        room.x + 112,
        room.y + 48,
        'FROM GHOSTS, TO KNIGHTS,\n\n TO MUMMIES, TO WISPS,\n\nTO WIZARDS-RETURN TO ME.',
      );
      room.misc.add(text);

      scene.events.once('roomtransitioncomplete', () => scene.sound.play('fairy'));

      const oldMan = room.spawnEntity({ type: 'oldman', spaceX: 7, spaceY: 3 }) as OldMan;
      oldMan.on('spawncomplete', () => {
        text.play();
      });

      return () => {};
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAACAgIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'redbrick',
    floorX: 3,
    floorY: 3,
    doorsConfig: { up: 'locked', down: 'locked', left: 'locked', right: null },
    entityConfigs: [
      { type: 'key', spaceX: 4, spaceY: 3 },
      { type: 'statue', spaceX: 3, spaceY: 3, options: { facing: 'right', delay: [230, 240] } },
      { type: 'statue', spaceX: 11, spaceY: 3, options: { facing: 'left', delay: [230, 240] } },

      {
        type: 'centaur',
        spaceX: 3,
        spaceY: 4,
        variant: 'red',
        options: {
          blockedSpaces: [
            { x: 11, y: 1 },
            { x: 11, y: 5 },
            { x: 3, y: 1 },
            { x: 3, y: 5 },
          ],
        },
      },
      {
        type: 'centaur',
        spaceX: 11,
        spaceY: 2,
        options: {
          blockedSpaces: [
            { x: 11, y: 1 },
            { x: 11, y: 5 },
            { x: 3, y: 1 },
            { x: 3, y: 5 },
          ],
        },
      },
    ],
    playerSpawn: { spaceX: 7, spaceY: 4 },
    onCreate(scene, room) {
      const bushConfigs = [
        { type: 'bush', spaceX: 11, spaceY: 1 },
        { type: 'bush', spaceX: 11, spaceY: 5 },
        { type: 'bush', spaceX: 3, spaceY: 1 },
        { type: 'bush', spaceX: 3, spaceY: 5 },
      ];

      if (gameState.isRoomSolved(this.key)) {
        for (const config of bushConfigs) {
          room.spawnEntity({ ...config, options: { burned: true } });
        }
        return () => {};
      }

      for (const config of bushConfigs) {
        room.spawnEntity(config);
      }

      let bushesBurned = 0;
      const handleBushBurned = () => {
        if (++bushesBurned === 4) {
          const [x, y] = room.maze.spaceXYToWorldXY(7, 3);
          gameState.addRoomItem(this.key, { id: `betterShield`, type: 'betterShield', x, y });
          gameState.solveRoom(this.key);
          scene.sound.play('secret');
        }
      };
      scene.events.on('burnbush', handleBushBurned);

      return () => {
        scene.events.off('burnbush', handleBushBurned);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAICAgACAQIAAgECAAIBAgACAQIAAgECAAICAgACAgIAAgECAAICAgACAQIAAgICAAACAgICAgABAQECAQIBAQICAgIBAgECAQICAgEBAgIBAgEBAQECAgIBAQECAQEBAQIBAQIBAgIBAgIBAgEBAgIAAgECAQIAAQIBAQECAQICAgECAQEBAgIBAQECAgIBAQECAgICAgEBAgECAQEBAgECAQECAQECAgEBAQEBAgECAAIBAgECAAEBAgEBAgEBAQICAgECAgIBAQICAgEBAQIBAQECAgIBAQEBAgEBAgEBAgIBAQECAgEBAgECAQIBAgACAQICAgACAgECAQEBAgICAQECAQECAgICAQECAQIBAQECAgEBAQECAgECAgECAgIBAgICAgICAgECAgECAgIAAgECAgIAAQECAgECAQEBAgICAQEBAgICAgEBAQICAQIBAQECAgICAQICAQIBAQECAQICAgICAQEBAgIBAQECAAIBAgECAAIBAQEBAQIBAgIBAQECAgICAQECAgEBAQEBAgECAQEBAgICAQEBAQIBAgEBAgEBAgECAQEBAgECAgACAgICAAABAgACAgIAAgECAAICAgACAQIAAgECAAICAgACAQIAAgICAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'bogeyman',
    floorX: 4,
    floorY: 3,
    doorsConfig: { up: 'open', down: 'locked', left: null, right: null },
    dark: true,
    entityConfigs: [{ type: 'key', spaceX: 7, spaceY: 6 }],
    playerSpawn: { spaceX: 7, spaceY: 0 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        room.isDark = false;
        room.setVisuallyDark(false);
        room.maze.clear();
        room.maze.syncTilemap();

        if (!gameState.hasItem('potion')) {
          room.spawnEntity({ type: 'potion', spaceX: 7, spaceY: 3 });
        }

        return () => {};
      }

      room.isDark = true;
      room.setVisuallyDark(true);
      room.maze.clear();
      room.maze.randomize();
      room.maze.syncTilemap();

      const enemyConfigs = [
        { type: 'kobold', spaceX: 2, spaceY: 6, variant: 'dark' },
        { type: 'kobold', spaceX: 13, spaceY: 5, variant: 'dark' },

        { type: 'gel', spaceX: 9, spaceY: 0, variant: 'dark' },
        { type: 'gel', spaceX: 2, spaceY: 4, variant: 'dark' },
        { type: 'gel', spaceX: 13, spaceY: 3, variant: 'dark' },
        { type: 'gel', spaceX: 4, spaceY: 5, variant: 'dark' },
        { type: 'gel', spaceX: 10, spaceY: 4, variant: 'dark' },

        { type: 'wizard', spaceX: 2, spaceY: 1, variant: 'darkWall' },
        { type: 'wizard', spaceX: 10, spaceY: 3, variant: 'darkWall' },
        { type: 'wizard', spaceX: 7, spaceY: 0, variant: 'darkWall' },

        { type: 'knight', spaceX: 3, spaceY: 2, variant: 'dark' },
        { type: 'knight', spaceX: 13, spaceY: 6, variant: 'dark' },
        { type: 'knight', spaceX: 9, spaceY: 3, variant: 'dark' },

        { type: 'centaur', spaceX: 12, spaceY: 1, variant: 'dark' },
        { type: 'centaur', spaceX: 1, spaceY: 1, variant: 'dark' },
      ];
      for (const config of enemyConfigs) {
        room.spawnEntity(config);
      }

      const handleTransitionDark = (newDark: boolean) => {
        if (!newDark) {
          room.maze.clear();
          room.maze.syncTilemap();

          for (const enemyObject of room.enemies.children) {
            enemyObject.destroy(true);
          }
        }
      };
      scene.events.on('pretransitiondark', handleTransitionDark);

      const handleEnemyDeath = async () => {
        if (room.enemies.getLength() < 1) {
          room.maze.clear();
          room.maze.syncTilemap();

          scene.sound.play('secret');
          room.spawnEntity({ type: 'potion', spaceX: 7, spaceY: 3 });

          scene.freeze();
          await room.transitionDark(false);
          room.isDark = false;
          scene.unfreeze();

          gameState.solveRoom(this.key);
        }
      };
      scene.events.on('enemydeath', handleEnemyDeath);

      return () => {
        scene.events.off('pretransitiondark', handleTransitionDark);
        scene.events.off('enemydeath', handleEnemyDeath);
      };
    },
    onPostRoomTransition(_scene, _room) {
      // As a kindness, make mattocks 3 times as effective in this room only
      gameState.mattockDurability = gameState.maxMattockDurability * 3;
    },
  },
  {
    key: 'squeak',
    floorX: 2,
    floorY: 4,
    doorsConfig: { up: 'locked', down: null, left: null, right: null },
    entityConfigs: [{ type: 'key', spaceX: 2, spaceY: 3 }],
    playerSpawn: { spaceX: 7, spaceY: 0 },
    onCreate(scene, room) {
      const { player } = scene;

      const [x, y] = room.maze.spaceXYToWorldXY(7, 3);
      const lava = scene.add.image(x, y, 'lava');
      room.misc.add(lava);

      const bodies = [
        scene.physics.add.staticBody(lava.x - 72, lava.y - 54, 144, 28),
        scene.physics.add.staticBody(lava.x - 72, lava.y + 22, 144, 32),
        scene.physics.add.staticBody(lava.x - 72, lava.y - 40, 32, 76),
        scene.physics.add.staticBody(lava.x + 40, lava.y - 40, 32, 76),
      ];

      const collider = scene.physics.add.collider(bodies, player);

      const handlePreUpdate = () => {
        player.canBeDropped = !scene.physics.overlap(bodies, player);
      };
      scene.events.on('preupdate', handlePreUpdate);

      const handleDragStart = () => {
        collider.active = false;
      };
      player.on('dragstart', handleDragStart);

      const handleDragEnd = () => {
        collider.active = true;
      };
      player.on('dragend', handleDragEnd);

      player.enableDrag();

      if (!gameState.isRoomSolved(this.key)) {
        const blueRod = room.spawnEntity({ type: 'blueRod', spaceX: 7, spaceY: 3 })!;
        blueRod.on('collect', () => {
          gameState.solveRoom(this.key);
        });
      }

      return () => {
        collider.destroy();
        scene.events.off('preupdate', handlePreUpdate);
        player.disableDrag();
        player.off('dragstart', handleDragStart);
        player.off('dragend', handleDragEnd);
        for (const body of bodies) {
          body.destroy();
        }
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAACAgIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'despiteeverything',
    floorX: 4,
    floorY: 2,
    doorsConfig: { up: 'closed', down: 'open', left: null, right: null },
    entityConfigs: [],
    playerSpawn: { spaceX: 3, spaceY: 2 },
    onCreate(scene, room) {
      room.floorSprite.setFrame(2);

      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      // Music fade out and back in
      scene.tweens.add({
        targets: [scene.music, scene.hurtMusic],
        volume: 0,
        duration: 1000,
      });
      scene.events.once('roomtransitionstart', () => {
        gameState.subweaponsDisabled = false;
        scene.tweens.add({
          targets: [scene.music, scene.hurtMusic],
          volume: 1,
          duration: 1000,
        });
      });

      gameState.subweaponsDisabled = true;

      const otherManager = new OtherManager(scene, room, sharedWorker);
      scene.events.once('roomtransitionplayerenter', () => {
        otherManager.enterRoom();
      });
      scene.events.once('roomtransitionstart', () => {
        otherManager.exitRoom();
      });

      const handleOtherDeath = (other: Other) => {
        scene.sound.play('secret');
        gameState.solveRoom(this.key);
        gameState.addRoomItem(this.key, { id: 'redRod', type: 'redRod', x: other.x, y: other.y });
      };
      scene.events.once('otherdeath', handleOtherDeath);

      const doorCollider = scene.physics.add.collider(scene.player, room.doors.up!.doorBody);

      return () => {
        otherManager.destroy();
        doorCollider.destroy();
        scene.events.off('otherdeath', handleOtherDeath);
      };
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAACAgIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'boss',
    floorX: 3,
    floorY: 2,
    doorsConfig: { up: 'closed', down: 'locked', left: null, right: null },
    entityConfigs: [{ type: 'key', spaceX: 11, spaceY: 3 }],
    playerSpawn: { spaceX: 7, spaceY: 6 },
    onCreate(scene, room) {
      room.floorSprite.setFrame(3);

      if (gameState.isRoomSolved(this.key)) {
        room.unlockDoor(Direction.Up);
        return () => {};
      }

      const boss = new Boss(scene, room, ...room.maze.spaceXYToWorldXY(7, 1));
      boss.once('death', () => {
        scene.sound.play('secret');
        gameState.solveRoom(this.key);
        room.unlockDoor(Direction.Up);
        gameState.addRoomItem(this.key, { id: 'magicKey', type: 'magicKey', x: boss.x, y: boss.y });
      });

      return () => {};
    },
    serializedLinks:
      'AAICAAACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAACAgIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQIBAgABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQIAAgECAQIAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECAAIBAgECAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAgACAQICAAABAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgECAAIBAgACAQIAAgIAAAI=',
  },
  {
    key: 'lastroom',
    floorX: 3,
    floorY: 1,
    doorsConfig: { up: 'closed', down: 'closed', left: null, right: null },
    entityConfigs: [],
    playerSpawn: { spaceX: 7, spaceY: 6 },
    onCreate(scene, room) {
      if (gameState.isRoomSolved(this.key)) {
        return () => {};
      }

      function winCheck() {
        if (gameState.getFlag('redRodPlaced') && gameState.getFlag('blueRodPlaced')) {
          room.doors.up!.state = 'stairs';
          scene.sound.play('openDoor');
        }
      }
      scene.events.once('roomtransitioncomplete', winCheck);

      const redPedastal = new Interactable(
        scene,
        room,
        ...room.maze.spaceXYToWorldXY(12, 2),
        'items',
        gameState.getFlag('redRodPlaced') ? 55 : 54,
        14,
        14,
      );
      redPedastal.on('interact', () => {
        if (!gameState.getFlag('redRodPlaced') && gameState.hasItem('redRod')) {
          gameState.removeItem('redRod');
          gameState.setFlag('redRodPlaced', true);
          redPedastal.setFrame(55);
          scene.sound.play('secret');
          winCheck();
        }
      });

      const bluePedastal = new Interactable(
        scene,
        room,
        ...room.maze.spaceXYToWorldXY(2, 2),
        'items',
        gameState.getFlag('blueRodPlaced') ? 56 : 54,
        14,
        14,
      );
      bluePedastal.on('interact', () => {
        if (!gameState.getFlag('blueRodPlaced') && gameState.hasItem('blueRod')) {
          gameState.removeItem('blueRod');
          gameState.setFlag('blueRodPlaced', true);
          bluePedastal.setFrame(56);
          scene.sound.play('secret');
          winCheck();
        }
      });

      const stairBody = scene.physics.add.body(room.doors.up!.x - 8, room.doors.up!.y + 4, 16, 8);
      const stairCollider = scene.physics.add.overlap(stairBody, scene.player, () => {
        stairCollider.active = false;
        scene.endGame();
      });

      return () => {
        redPedastal.destroy();
        bluePedastal.destroy();
        stairBody.destroy();
        stairCollider.destroy();
      };
    },
    serializedLinks:
      'AAICAAACAgIAAgICAAICAgACAgIAAgICAAIBAgACAQIAAgECAAIBAgACAgIAAgICAAIBAgACAgIAAgICAAACAgIBAgACAQEBAgEBAQIBAQECAQEBAgECAQEBAQEBAQEBAQEBAQEBAQECAQIBAgEBAQEBAgECAQEBAgEBAQIAAgECAgIAAQIBAgEBAgIBAQIBAQECAQIBAgEBAQEBAQEBAQEBAQEBAQEBAgECAQECAgECAgECAQECAgECAQECAAICAgECAAEBAgECAgEBAgEBAgICAgECAQECAQEBAQEBAQEBAQEBAQEBAQIBAQECAQIBAQIBAQICAgIBAQICAgACAQIBAgACAgEBAQIBAgECAgICAQECAQECAQEBAQEBAQEBAQEBAQEBAQEBAgIBAgIBAgEBAQICAQEBAgECAQIAAgECAQIAAQIBAQEBAgICAQIBAQICAQIBAgIBAQEBAQEBAQEBAQEBAQEBAgECAQECAQEBAQICAQICAQIBAQICAAIBAgECAAEBAgECAgEBAgEBAgIBAQECAQIBAQEBAQEBAQEBAQEBAQEBAQIBAgEBAgEBAgIBAgIBAQIBAQIBAgACAQICAAACAgACAQIAAgECAAIBAgACAgIAAgECAAIBAgACAQIAAgECAAICAgACAQIAAgECAAIBAgACAgIAAgIAAAI=',
  },
];

export default FLOOR1;
